import React, { FC } from 'react'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import * as SC from './styled'

export type FooterProps = {
  className?: string
  text: string
}

const Footer: FC<FooterProps> = (props) => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()
  const text = `© ${currentYear} Balenciaga`
  const { className} = props

  const handleCookieSettings = () => {
    if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
      window.OneTrust.ToggleInfoDisplay()
    } else if (window.Optanon && window.Optanon.ToggleInfoDisplay) {
      window.Optanon.ToggleInfoDisplay()
    }
  }

  return (
    <SC.Footer className={cx(className)}>
      <SC.FooterContent>
        <SC.CookieButton 
          type="button"
          onClick={handleCookieSettings}
        >
          {t('cookieSettings')}
        </SC.CookieButton>
        <SC.Separator>|</SC.Separator>
        <SC.CookieLink 
          href="https://www.balenciaga.com/legal/politique-des-cookies/cookie-policy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('cookiePolicy')}
        </SC.CookieLink>
        <SC.Separator>|</SC.Separator>
        <SC.Text>{text}</SC.Text>
      </SC.FooterContent>
    </SC.Footer>
  )
}

export default Footer
